import {
  filterDocumentUploadFiles,
  getDocumentUploadFilePath,
} from '../utils/documentUploadFiles';

const DEFAULT_SHARED_VIEWER_API_ORIGIN = 'https://api.casedb.co';

export const getSharedViewerApiEndpoint = () => {
  const configuredOrigin = String(process.env.REACT_APP_API_BASE_URL || '')
    .trim()
    .replace(/\/+$/, '');
  return `${configuredOrigin || DEFAULT_SHARED_VIEWER_API_ORIGIN}/share.php`;
};

export const prepareSharedViewerUploadFiles = (files) => (
  filterDocumentUploadFiles(Array.from(files || []))
);

export const buildSharedViewerUploadFormData = (files) => {
  const uploadFiles = prepareSharedViewerUploadFiles(files);
  const formData = new FormData();

  uploadFiles.forEach((file, index) => {
    formData.append('file[]', file);

    const relativePath = getDocumentUploadFilePath(file);
    if (relativePath && relativePath !== file.name) {
      formData.append(`relative_paths[${index}]`, relativePath);
    }
  });

  return { files: uploadFiles, formData };
};

const getSharedViewerUploadError = (response, fallback) => {
  if (response?.message) return response.message;
  if (Array.isArray(response?.errors) && response.errors.length > 0) {
    return response.errors.join(' ');
  }
  return fallback;
};

export const uploadSharedViewerFiles = ({
  files,
  token,
  path = '',
  onProgress,
  createRequest = () => new XMLHttpRequest(),
  endpoint = getSharedViewerApiEndpoint(),
}) => {
  const { files: uploadFiles, formData } = buildSharedViewerUploadFormData(files);
  if (uploadFiles.length === 0) {
    return Promise.resolve({ success: true, uploaded_files: [] });
  }

  return new Promise((resolve, reject) => {
    let xhr;

    try {
      xhr = createRequest();
      xhr.upload.addEventListener('progress', (event) => {
        if (!event.lengthComputable || typeof onProgress !== 'function') return;
        onProgress(Math.round((event.loaded / event.total) * 100));
      });

      xhr.onload = () => {
        let response;
        try {
          response = JSON.parse(xhr.responseText || '{}');
        } catch (_) {
          reject(new Error('The upload service returned an invalid response.'));
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          reject(new Error(getSharedViewerUploadError(response, `Upload failed with status ${xhr.status}.`)));
          return;
        }
        if (!response.success) {
          reject(new Error(getSharedViewerUploadError(response, 'The upload failed.')));
          return;
        }

        resolve(response);
      };

      xhr.onerror = () => reject(new Error('The upload failed due to a network error.'));
      xhr.open(
        'POST',
        `${endpoint}?token=${encodeURIComponent(token)}&upload=1&path=${encodeURIComponent(path)}`,
      );
      xhr.withCredentials = true;
      xhr.send(formData);
    } catch (error) {
      reject(error);
    }
  });
};
